import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tabs,
  Tab,
  OverlayTrigger,
  Tooltip,
  InputGroup,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchData,
  fetchHistory,
  fetchId,
  fetchIdNoloading,
  fetchTemplate,
  resetData,
  selectId,
  selectIdHistory,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./specialDiscSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  checkEmptyFields,
  validatePrice,
  paramsMasterAll,
  setOptionsMaster,
  formatterStatus,
  columnsOrder,
  formatCurrency,
  formatQuantity,
  akhirBulan,
  awalBulan,
  formatDate,
  useForceUpdate,
  formatTanggal,
  paramsCalculationType,
  paramsYesNoType,
  paramsActiveType,
  statusFormatter,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchUom, selectUom } from "../uom/uomSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { InputDateRange } from "../../utility/InputDateRange";
import { NavLink } from "react-router-dom";
import InputNumber from "../../utility/InputNumber";
import { useLocation } from "react-router-dom";
import { fetchProduct, selectProduct } from "../product/productSlice";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import { DateRangePicker } from "react-date-range";
import { InputDateRangeForm } from "../../utility/InputDateRangeForm";
import SVG from "react-inlinesvg";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaAngleDown,
  FaAngleRight,
  FaAngleUp,
} from "react-icons/fa";
import { ModalProduct } from "../../utility/ModalProduct";
import { ModalStepper } from "./ModalStepper";
import { ModalBonus } from "./ModalBonus";
export const SpecialDiscCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataProduct = useSelector(selectProduct);
  const { id } = useParams();
  const ref = useRef();
  const { SearchBar } = Search;
  const forceUpdate = useForceUpdate();
  const location = useLocation();
  const dataBranch = useSelector(selectBranch);
  const dataParam = useSelector(selectDataParam);

  const [branch, setBranch] = useState("");
  const [custGroup, setCustGroup] = useState("");
  const [name, setName] = useState("");
  const [nameCopy, setNameCopy] = useState("");
  const [code, setCode] = useState("");
  const [uom, setUom] = useState("");
  const [desc, setDesc] = useState("");
  const [descCopy, setDescCopy] = useState("");
  const [product, setProduct] = useState("");
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const [noTableProduct, setNoTableProduct] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateCopy, setStartDateCopy] = useState("");
  const [endDateCopy, setEndDateCopy] = useState("");
  const [qty, setQty] = useState("");
  const [persen, setPersen] = useState("");
  const [showProduct, setShowProduct] = useState(false);
  const [showBonus, setShowBonus] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  console.log(selectedRows, "selectedRows");

  const [tableData, setTableData] = useState([]);
  const [tableDataBonus, setTableDataBonus] = useState([]);
  const [optionsProduct, setOptionsProduct] = useState([]);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [optionsCustGroup, setOptionsCustGroup] = useState([]);

  const [inputSelect, setInputSelect] = useState("");
  const [calculationType, setCalculationType] = useState("");

  const [percentage, setPercentage] = useState({
    level_1: "",
    level_2: "",
    level_3: "",
  });

  const [amount, setAmount] = useState({
    level_1: "",
    level_2: "",
    level_3: "",
  });

  console.log(amount, "amount");
  console.log(percentage, "percentage");

  const levels = ["level_1", "level_2", "level_3"];

  const [show, setShow] = useState(false);

  const paramsId = {
    special_discount_id: id,
  };

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
      await dispatch(fetchProduct(paramsMasterAll));

      await dispatch(fetchBranch(paramsMasterAll));
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setProduct(dataId?.product_id);
      setBranch(dataId?.branch_code);
      setCustGroup(dataId?.customer_group);

      setQty(dataId?.min_quantity);
      setName(dataId?.special_discount_name);
      setDesc(dataId?.special_discount_description);
      setStartDate(dataId?.start_at);
      setEndDate(dataId?.end_at);
      setTableData(
        dataId?.special_discount_products?.map((item, index) => ({
          ...item,
          no: index + 1, // Adding a row number, starting from 1
        }))
      );
    }
  }, [dataId]);

  useEffect(() => {
    if (dataProduct.length > 0) {
      const initData = dataProduct.map((item) => ({
        ...item,
        label: item.product_name,
        value: item.product_id,
      }));
      setOptionsProduct(initData);
    }
  }, [dataProduct]);

  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionsBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(
        dataParam,
        setOptionsCustGroup,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam]);

  const handleSave = async () => {
    let hasError = false; // Variable to track if there is any error

    const fields = [
      { value: name, message: "input Discount Name", valid: true },
      { value: startDate, message: "input Discount Periode", valid: true },
      { value: endDate, message: "input Discount Periode", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const params = {
      special_discount_id: id,
      special_discount_name: name,
      special_discount_description: desc,
      branch_code: branch,
      customer_group: custGroup,
      start_at: startDate,
      end_at: endDate,
      special_discount_products: tableData,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleClose = () => {
    setProduct("");
    setProductCode("");
    setProductName("");
    setUom("");
    setCalculationType("");
    setQty("");
    setPercentage({
      level_1: "0",
      level_2: "0",
      level_3: "0",
    });

    setAmount({
      level_1: "0",
      level_2: "0",
      level_3: "0",
    });
    setTableDataBonus([]);
    forceUpdate();
    setShow(false);
  };

  const handleSubmitDetail = async () => {
    // Data yang akan ditambahkan atau diperbarui
    const newData = {
      no: noTableProduct,
      product_id: product,
      product_code: productCode,
      product_name: productName,
      uom_code: uom,
      calculation_type: calculationType,
      min_quantity: qty,
      percentage_level_1: percentage?.level_1,
      amount_level_1: amount?.level_1,
      percentage_level_2: percentage?.level_2,
      amount_level_2: amount?.level_2,
      percentage_level_3: percentage?.level_3,
      amount_level_3: amount?.level_3,
      special_discount_bonus_items: tableDataBonus,
    };

    // Periksa apakah product_id sudah ada di tableData
    const updatedTableData = tableData.map((item) =>
      item.no === noTableProduct
        ? { ...item, ...newData } // Update jika ada
        : item
    );

    // Update state
    setTableData(updatedTableData);
    forceUpdate();
    handleClose();
  };

  const handleChangeUom = createChangeHandler(setUom);

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload.filter(
      (entry) => entry.status_validation === "Success"
    );

    if (tableUpload.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchId, dispatch);
        handleCloseUpload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "product",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      formatter: (cell, row) => (
        <div>
          <span>
            <b>{row.product_code}</b>
          </span>
          <br />
          <span>{row.product_name}</span>
        </div>
      ),
    },
    {
      text: "min quantity",
      dataField: "min_quantity",

      align: "right",
    },
    {
      text: "uom",
      dataField: "uom_description",
      style: { minWidth: "240px" },
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "calculation type",
      dataField: "calculation_type",
      style: { minWidth: "240px" },
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "percentage_level_1",
      dataField: "percentage_level_1",
      style: { minWidth: "240px" },
      align: "right",
      headerFormatter: (column) => (
        <>
          <Row className="combine-col-header justify-content-center">
            Level 1
          </Row>
          <div
            style={{ borderBottom: "1px solid #dee2e6", marginBottom: "5px" }}
          ></div>
          <Row gutter={0} align="middle">
            <Col span={11}>Disc(%)</Col>
            <Col>
              <div
                style={{
                  height: "20px", // Adjust height as needed
                  borderLeft: "1px solid #dee2e6", // Vertical line
                  margin: "0 10px", // Add some space around the line
                }}
              ></div>
            </Col>
            <Col span={11}>Disc(Rp)</Col>
          </Row>
        </>
      ),
      formatter: (cell, row) => (
        <Row gutter={24}>
          {" "}
          <Col span={12}>{cell} </Col> <Col span={12}>{row.amount_level_1}</Col>{" "}
        </Row>
      ),
    },
    {
      text: "percentage_level_2",
      dataField: "percentage_level_2",
      style: { minWidth: "240px" },
      align: "right",
      headerFormatter: (column) => (
        <>
          <Row className="combine-col-header justify-content-center">
            Level 2
          </Row>
          <div
            style={{ borderBottom: "1px solid #dee2e6", marginBottom: "5px" }}
          ></div>
          <Row gutter={0} align="middle">
            <Col span={11}>Disc(%)</Col>
            <Col>
              <div
                style={{
                  height: "20px", // Adjust height as needed
                  borderLeft: "1px solid #dee2e6", // Vertical line
                  margin: "0 10px", // Add some space around the line
                }}
              ></div>
            </Col>
            <Col span={11}>Disc(Rp)</Col>
          </Row>
        </>
      ),
      formatter: (cell, row) => (
        <Row gutter={24}>
          {" "}
          <Col span={12}>{cell} </Col> <Col span={12}>{row.amount_level_2}</Col>{" "}
        </Row>
      ),
    },
    {
      text: "percentage_level_3",
      dataField: "percentage_level_3",
      style: { minWidth: "240px" },
      align: "right",
      headerFormatter: (column) => (
        <>
          <Row className="combine-col-header justify-content-center">
            Level 3
          </Row>
          <div
            style={{ borderBottom: "1px solid #dee2e6", marginBottom: "5px" }}
          ></div>
          <Row gutter={0} align="middle">
            <Col span={11}>Disc(%)</Col>
            <Col>
              <div
                style={{
                  height: "20px", // Adjust height as needed
                  borderLeft: "1px solid #dee2e6", // Vertical line
                  margin: "0 10px", // Add some space around the line
                }}
              ></div>
            </Col>
            <Col span={11}>Disc(Rp)</Col>
          </Row>
        </>
      ),
      formatter: (cell, row) => (
        <Row gutter={24}>
          {" "}
          <Col span={12}>{cell} </Col> <Col span={12}>{row.amount_level_3}</Col>{" "}
        </Row>
      ),
    },
    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];
  const columnsDetail = [
    {
      text: "product",
      dataField: "product_code",
      style: { minWidth: "120px" },
      formatter: (cell, row) => (
        <div>
          <span>
            <b>{row.product_code}</b>
          </span>
          <br />
          <span>{row.product_name}</span>
        </div>
      ),
    },
    {
      text: "Uom",
      dataField: "uom_description",
      style: { minWidth: "60px" },
    },
    {
      text: "bonus qty",
      dataField: "bonus_quantity",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
  ];

  const expandRowUpload = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    renderer: (row) => (
      <BootstrapTable
        keyField="product_code"
        data={
          row.special_discount_bonus_items.length === 0
            ? []
            : row.special_discount_bonus_items
        }
        columns={columnsDetail}
      />
    ),
    expandColumnRenderer: ({ expanded, rowKey, expandable }) =>
      expandable ? expanded ? <FaAngleUp /> : <FaAngleDown /> : null,

    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
    nonExpandable: tableUpload
      .filter((row) => row.special_discount_bonus_items.length === 0)
      .map((row) => row.no), // Replace 'id' with the actual key field of your row
  };

  const handleDownload = async () => {
    const params = {
      file_type: "SPECIAL_DISCOUNT",
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "SPECIAL_DISCOUNT.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              setProduct(row.product_id);
              setProductCode(row.product_code);
              setProductName(row.product_name);
              setUom(row.uom);
              setCalculationType(row.calculation_type);
              setQty(row.min_quantity);
              setPercentage({
                level_1: row.percentage_level_1,
                level_2: row.percentage_level_2,
                level_3: row.percentage_level_3,
              });

              setAmount({
                level_1: row.amount_level_1,
                level_2: row.amount_level_2,
                level_3: row.amount_level_3,
              });
              setTableDataBonus(row.special_discount_bonus_items);
              setShow(true);
              forceUpdate();
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>

        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() =>
              setTableData((prevTableDataBonus) =>
                prevTableDataBonus.filter((_, index) => index !== rowIndex)
              )
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const handleChangeBranch = createChangeHandler(setBranch);
  const handleChangeCustGroup = createChangeHandler(setCustGroup);
  const handleChangeType = createChangeHandler(setCalculationType);

  const handleChangeProduct = (e) => {
    if (e === null) {
      e = undefined;
      setProduct("");
      setProductCode("");
      setProductName("");
      setProduct("");
      setUom("");
    } else {
      setProduct(e.value);
      setProductCode(e.product_code);
      setProductName(e.product_name);
      setUom(e.uom_code);
    }
  };

  const handleInputLvlPercen = (e, level) => {
    let value = parseFloat(e.target.value);

    // Jika value adalah NaN, setel ke 0
    if (isNaN(value)) {
      value = 0;
    }

    // Batasi nilai antara 0 dan 100
    value = Math.max(0, Math.min(100, value));

    setPercentage((prev) => ({
      ...prev,
      [level]: value,
    }));
  };

  const handleInputLvlAmount = (value, level) => {
    // Convert input to a number and set to 0 if it's NaN
    let numericValue = parseFloat(value) || 0;

    // Prevent negative values
    if (numericValue < 0) {
      numericValue = 0;
    }

    setAmount((prev) => ({
      ...prev,
      [level]: numericValue.toString(),
    }));
  };

  const handleAddBonus = () => {
    setShow(false);
    setShowBonus(true);
  };

  const handleDeleteBonus = (noToDelete) => {
    // Step 1: Update the tableDataBonus by removing the item with noToDelete
    const updatedTableDataBonus = tableDataBonus
      .filter((item) => item.no !== noToDelete)
      .map((item, index) => ({
        ...item,
        no: index + 1,
      }));

    // Step 2: Update the tableData with the new special_discount_bonus_items
    setTableData((prevData) => {
      const updatedData = prevData.map((item) => {
        // Check if the current item's 'no' matches 'noTableProduct'
        if (item.no === noTableProduct) {
          return {
            ...item,
            special_discount_bonus_items: updatedTableDataBonus,
          };
        }
        return item; // Return unchanged item if no match
      });

      // Optionally update tableDataBonus here if needed
      setTableDataBonus(updatedTableDataBonus);

      return updatedData;
    });
  };

  const handleDeleteTableData = (noToDelete) => {
    setTableData((prevTableDataBonus) => {
      // Filter data untuk menghapus item berdasarkan properti 'no'
      const updatedTableData = prevTableDataBonus.filter(
        (item) => item.no !== noToDelete
      );

      // Tambahkan kembali nomor urut
      return updatedTableData.map((item, index) => ({
        ...item,
        no: index + 1,
      }));
    });
  };

  const [search, setSearch] = useState("");

  const handleBonusChange = (index, field, value) => {
    const updatedData = [...tableDataBonus];
    updatedData[index] = { ...updatedData[index], [field]: value };
    setTableDataBonus(updatedData);
  };

  const handleBonusProductChange = (index, field, value) => {
    const updatedData = [...tableDataBonus];
    updatedData[index] = {
      ...updatedData[index],
      [field]: value.value,
      product_name: value.product_name,
      product_code: value.product_code,
      uom: value.uom_code,
    };
    setTableDataBonus(updatedData);
  };

  const filteredData = tableDataBonus.filter((item) => {
    const searchTerm = search.toLowerCase();
    return Object.values(item).some(
      (value) =>
        value != null &&
        value
          .toString()
          .toLowerCase()
          .includes(searchTerm)
    );
  });

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    // expanded: [0, 1],
    renderer: (row) => (
      <BootstrapTable
        keyField="no"
        data={
          row.special_discount_bonus_items === null
            ? []
            : row.special_discount_bonus_items
        }
        columns={columnsBonus}
      />
    ),
    expandColumnRenderer: ({ expanded, rowKey, expandable }) =>
      expandable ? expanded ? <FaAngleUp /> : <FaAngleDown /> : null,
    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
  };

  const columnsBonus = [
    {
      text: "bonus product",
      dataField: "product_code",
      style: { minWidth: "120px" },
      formatter: (cell, row) => (
        <div>
          <span>
            <b>{row.product_code}</b>
          </span>
          <br />
          <span>{row.product_name}</span>
        </div>
      ),
    },

    {
      text: "bonus qty",
      dataField: "bonus_quantity",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "min bonus qty",
      dataField: "bonus_min_quantity",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "apply multiples",
      dataField: "is_apply_multiples",
      style: { minWidth: "120px" },
      formatter: formatterStatus,
    },
    {
      text: "is active",
      dataField: "is_active",
      style: { minWidth: "120px" },
      formatter: statusFormatter,
    },
  ];

  // New fuc detail product
  const [searchTerm, setSearchTerm] = useState("");

  // Handler to update table data
  const handleInputChange = (index, field, value) => {
    const newValue = parseFloat(value);
    const newData = [...tableData];

    if (field.startsWith("percentage") && (newValue < 0 || newValue > 100)) {
      return; // Prevent invalid values for percentage fields
    }

    if (newValue >= 0 || !isNaN(newValue)) {
      newData[index][field] = newValue;
      setTableData(newData);
    }
  };

  // Add a new row
  const addRow = () => {
    const lastNo =
      tableData.length > 0 ? tableData[tableData.length - 1].no : 0;
    const newRow = {
      no: lastNo + 1,
      product_id: "",
      product_code: "",
      product_name: "",
      uom_code: "",
      calculation_type: "",
      min_quantity: 0,
      percentage_level_1: 0,
      amount_level_1: 0,
      percentage_level_2: 0,
      amount_level_2: 0,
      percentage_level_3: 0,
      amount_level_3: 0,
      special_discount_bonus_items: [],
    };
    setTableData((prevTableDataBonus) => [...prevTableDataBonus, newRow]);
  };

  // Filter data based on search term
  const filteredTableData = tableData.filter((row) =>
    Object.values(row).some((value) =>
      (value ? value.toString() : "") // Check if value is not null or undefined
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  );

  const handleProductChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index] = {
      ...updatedData[index],
      [field]: value.value,
      product_name: value.product_name,
      product_code: value.product_code,
      uom_code: value.uom_code,
    };

    setTableData(updatedData);
  };

  const handleTypeChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index] = {
      ...updatedData[index],
      [field]: value.value,
    };

    setTableData(updatedData);
  };

  // Func Copy

  const handleCloseCopy = () => {
    setNameCopy("");
    setDescCopy("");
    setStartDateCopy("");
    setEndDateCopy("");
    setShowCopy(false);
  };

  const handleSaveCopy = async () => {
    let hasError = false; // Variable to track if there is any error

    const fields = [
      { value: nameCopy, message: "input Discount Name", valid: true },
      { value: startDateCopy, message: "input Discount Periode", valid: true },
      { value: endDateCopy, message: "input Discount Periode", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const params = {
      special_discount_name: nameCopy,
      special_discount_description: descCopy,
      branch_code: branch,
      customer_group: custGroup,
      start_at: startDateCopy,
      end_at: endDateCopy,
      special_discount_products: tableData,
    };

    try {
      const response = await dispatch(addItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const special_discount_id = {
          special_discount_id: response.payload.data.data.special_discount_id,
        };

        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(special_discount_id, fetchIdNoloading, dispatch);
        await history.push(
          `/master/special-disc/edit/${response.payload.data.data.special_discount_id}`
        );

        await handleCloseCopy();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Special Discount"
              : "Edit Special Discount"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            {id !== undefined && (
              <Button
                className="btn btn-outline-warning mr-3"
                onClick={() => setShowCopy(true)}
              >
                Copy
              </Button>
            )}

            {id !== undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form.Group as={Row}>
            <Col sm={6}>
              {id !== undefined && (
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Special Disc Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.special_discount_code}
                      disabled
                    />
                  </Col>
                </Form.Group>
              )}
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Special Disc <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Description</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    as="textarea"
                    onChange={(e) => setDesc(e.target.value)}
                    value={desc}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Period Date <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <InputDateRangeForm
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    startDate={startDate}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Group</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsCustGroup}
                    value={getValueStatus(custGroup, optionsCustGroup)}
                    placeholder="Select ..."
                    onChange={handleChangeCustGroup}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </CardBody>

        <CardHeader title="Details Product" />
        <CardBody>
          <div>
            <div className="d-flex justify-content-between mb-3">
              <button
                className="btn btn-outline-danger"
                onClick={() => setShowProduct(true)}
              >
                Add Product
              </button>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ maxWidth: "300px" }}
              />
            </div>

            <div className="table-responsive table-container">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        minWidth: "60px",
                        left: 0,
                        zIndex: 3,
                        backgroundColor: "white",
                      }}
                      rowSpan="2"
                    >
                      No
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        minWidth: "280px",
                        left: "60px",
                        zIndex: 3,
                        backgroundColor: "white",
                      }}
                      rowSpan="2"
                    >
                      Product
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                      }}
                      rowSpan="2"
                    >
                      UOM
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                      }}
                      rowSpan="2"
                    >
                      Bonus
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                      }}
                      rowSpan="2"
                    >
                      Calculation
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                        textAlign: "center",
                      }}
                      rowSpan="2"
                    >
                      Min Quantity
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                        textAlign: "center",
                      }}
                      colSpan="2"
                    >
                      Level 1
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                        textAlign: "center",
                      }}
                      colSpan="2"
                    >
                      Level 2
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                        textAlign: "center",
                      }}
                      colSpan="2"
                    >
                      Level 3
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "white",
                        textAlign: "center",
                      }}
                      rowSpan="2"
                    >
                      Actions
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{
                        position: "sticky",
                        top:
                          "46px" /* Adjust if needed to match the height of the first row */,
                      }}
                    >
                      Disc(%)
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top:
                          "46px" /* Adjust if needed to match the height of the first row */,
                      }}
                    >
                      Disc(Rp)
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top:
                          "46px" /* Adjust if needed to match the height of the first row */,
                      }}
                    >
                      Disc(%)
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top:
                          "46px" /* Adjust if needed to match the height of the first row */,
                      }}
                    >
                      Disc(Rp)
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top:
                          "46px" /* Adjust if needed to match the height of the first row */,
                      }}
                    >
                      Disc(%)
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        top:
                          "46px" /* Adjust if needed to match the height of the first row */,
                      }}
                    >
                      Disc(Rp)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTableData.map((row, index) => (
                    <tr key={index}>
                      <td
                        className="sticky-col"
                        style={{
                          minWidth: "60px",
                          left: 0,
                          zIndex: 2,
                          backgroundColor: "white",
                        }}
                      >
                        {row.no}
                      </td>
                      <td
                        className="sticky-col"
                        style={{
                          minWidth: "280px",
                          left: "60px",
                          zIndex: 2,
                          backgroundColor: "white",
                        }}
                      >
                        <b> {row.product_code} </b>
                        <br />
                        <p> {row.product_name} </p>
                      </td>

                      <td>{row.uom_description}</td>
                      <td>
                        {row.special_discount_bonus_items.length > 0
                          ? "Yes"
                          : "No"}
                      </td>
                      <td style={{ minWidth: "150px" }}>
                        <p>{row.calculation_type} </p>
                      </td>
                      <td style={{ minWidth: "150px" }}>
                        <p className="text-right">{row.min_quantity} </p>
                      </td>
                      <td style={{ minWidth: "100px" }}>
                        <p className="text-right">{row.percentage_level_1} </p>
                      </td>
                      <td style={{ minWidth: "150px", textAlign: "right" }}>
                        <p>{formatCurrency(row.amount_level_1)} </p>
                      </td>
                      <td style={{ minWidth: "100px" }}>
                        <p className="text-right">{row.percentage_level_2} </p>
                      </td>
                      <td style={{ minWidth: "150px", textAlign: "right" }}>
                        <p>{formatCurrency(row.amount_level_2)} </p>
                      </td>
                      <td style={{ minWidth: "100px" }}>
                        <p className="text-right">{row.percentage_level_3} </p>
                      </td>
                      <td style={{ minWidth: "150px" }}>
                        <p>{formatCurrency(row.amount_level_3)} </p>
                      </td>
                      <td style={{ minWidth: "150px" }}>
                        <div>
                          <OverlayTrigger
                            overlay={
                              <Tooltip id="products-edit-tooltip">Edit</Tooltip>
                            }
                          >
                            <div
                              className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
                              onClick={() => {
                                setNoTableProduct(row.no);
                                setProduct(row.product_id);
                                setProductCode(row.product_code);
                                setProductName(row.product_name);
                                setUom(row.uom);
                                setCalculationType(row.calculation_type);
                                setQty(row.min_quantity);
                                setPercentage({
                                  level_1: row.percentage_level_1,
                                  level_2: row.percentage_level_2,
                                  level_3: row.percentage_level_3,
                                });

                                setAmount({
                                  level_1: row.amount_level_1,
                                  level_2: row.amount_level_2,
                                  level_3: row.amount_level_3,
                                });
                                setTableDataBonus(
                                  row.special_discount_bonus_items.map(
                                    (item, index) => ({
                                      ...item,
                                      no: index + 1,
                                    })
                                  )
                                );
                                setShow(true);
                                forceUpdate();
                              }}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-secondary">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Search.svg"
                                  )}
                                />
                              </span>
                            </div>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={
                              <Tooltip id="products-delete-tooltip">
                                Delete
                              </Tooltip>
                            }
                          >
                            <div
                              className="btn btn-icon btn-light btn-hover-danger btn-sm"
                              onClick={(e) => handleDeleteTableData(row.no)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-danger">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Trash.svg"
                                  )}
                                />
                              </span>
                            </div>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Special Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <ToolkitProvider
              keyField="no"
              data={tableUpload}
              columns={columns}
              search
            >
              {(props) => (
                <div className="mt-5">
                  <Row>
                    <Col></Col>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-container ">
                    <BootstrapTable
                      // wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center"
                      bootstrap4
                      bordered={true}
                      {...props.baseProps}
                      expandRow={expandRowUpload}
                    />
                  </div>
                </div>
              )}
            </ToolkitProvider>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-80"
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Special Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Product Code</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control type="text" value={productCode} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Product Name</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    as="textarea"
                    value={productName}
                    rows={4}
                    disabled
                  />
                </Col>
              </Form.Group>
              {/* <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control type="text" value={uom} disabled />
                </Col>
              </Form.Group> */}
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Min Qty</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="number"
                    onChange={(e) => setQty(e.target.value)}
                    value={qty}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Calculation Type <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    options={paramsCalculationType}
                    value={getValueStatus(
                      calculationType,
                      paramsCalculationType
                    )}
                    placeholder="Select ..."
                    onChange={handleChangeType}
                    // isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Header className="pt-0 pb-0">
          <Modal.Title>Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            {levels.map((level, index) => (
              <Col key={index} sm={12} md={6} lg={4} className="level-border">
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm={12}>
                    <b>
                      {level
                        .replace("_", " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                    </b>
                  </Form.Label>
                  <Col sm={4} xs={12}>
                    <InputGroup className="mb-3">
                      <Form.Control
                        type="number"
                        step="0.1"
                        onChange={(e) => handleInputLvlPercen(e, level)}
                        value={percentage[level]}
                        className="text-right"
                      />
                      <InputGroup.Prepend>
                        <InputGroup.Text>%</InputGroup.Text>
                      </InputGroup.Prepend>
                    </InputGroup>
                  </Col>
                  <Col sm={8} xs={12}>
                    <InputGroup className="mb-3">
                      <CurrencyInput
                        id={`input-${level}`}
                        className="form-control text-right"
                        name={level}
                        placeholder=""
                        decimalsLimit={2}
                        onValueChange={(value) =>
                          handleInputLvlAmount(value, level)
                        }
                        groupSeparator=","
                        decimalSeparator="."
                        value={amount[level] ?? ""}
                      />
                      <InputGroup.Prepend>
                        <InputGroup.Text>Rp</InputGroup.Text>
                      </InputGroup.Prepend>
                    </InputGroup>
                  </Col>
                </Form.Group>
              </Col>
            ))}
          </Form.Group>
        </Modal.Body>
        <Modal.Header className="pt-0 pb-0">
          <Modal.Title>Bonus Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "10px",
              }}
            ></div>

            <div className="d-flex justify-content-between mb-3">
              <button
                className="btn btn-outline-danger"
                onClick={handleAddBonus}
              >
                Add Bonus
              </button>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ maxWidth: "300px" }}
              />
            </div>

            <div className="table-responsive table-container">
              <table
                className="table table-bordered table-hover"
                style={{ borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Product</th>
                    <th>UOM</th>
                    <th>Apply Multiples</th>
                    <th>Bonus Quantity</th>
                    <th>Active</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.no}</td>
                      <td>
                        <b> {item.product_code} </b>
                        <br />
                        <p> {item.product_name} </p>
                      </td>
                      <td>{item.uom_description}</td>
                      <td>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={paramsYesNoType}
                          value={getValueStatus(
                            item.is_apply_multiples,
                            paramsYesNoType
                          )}
                          placeholder="Select ..."
                          onChange={(e) =>
                            handleBonusChange(
                              index,
                              "is_apply_multiples",
                              e.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={item.bonus_quantity}
                          onChange={(e) =>
                            handleBonusChange(
                              index,
                              "bonus_quantity",
                              e.target.value
                            )
                          }
                          style={{ width: "100%", textAlign: "right" }}
                          className="input-qty-return"
                        />
                      </td>
                      <td style={{ minWidth: "130px" }}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={paramsActiveType}
                          value={getValueStatus(
                            item.is_active,
                            paramsActiveType
                          )}
                          placeholder="Select ..."
                          onChange={(e) =>
                            handleBonusChange(index, "is_active", e.value)
                          }
                        />
                      </td>
                      <td>
                        <div>
                          <OverlayTrigger
                            overlay={
                              <Tooltip id="products-delete-tooltip">
                                Delete
                              </Tooltip>
                            }
                          >
                            <div
                              className="btn btn-icon btn-light btn-hover-danger btn-sm"
                              onClick={() => handleDeleteBonus(item.no)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-danger">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Trash.svg"
                                  )}
                                />
                              </span>
                            </div>
                          </OverlayTrigger>
                        </div>
                      </td>{" "}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleSubmitDetail}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCopy}
        onHide={handleCloseCopy}
        size="lg"
        dialogClassName="modal-80"
      >
        <Modal.Header closeButton>
          <Modal.Title> Copy Special Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Special Disc <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    onChange={(e) => setNameCopy(e.target.value)}
                    value={nameCopy}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Description</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    as="textarea"
                    onChange={(e) => setDescCopy(e.target.value)}
                    value={descCopy}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Period Date <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <InputDateRangeForm
                    setEndDate={setEndDateCopy}
                    setStartDate={setStartDateCopy}
                    endDate={endDateCopy}
                    startDate={startDateCopy}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseCopy()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleSaveCopy}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>

      {/* <ModalProduct show={showProduct} setShow={setShowProduct} /> */}
      <ModalStepper
        show={showProduct}
        setShow={setShowProduct}
        tableData={tableData}
        setTableData={setTableData}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
      <ModalBonus
        show={showBonus}
        setShow={setShowBonus}
        showProduct={show}
        setShowProduct={setShow}
        setTableDataBonus={setTableDataBonus}
        targetNo={noTableProduct}
        setIndex={setNoTableProduct}
        tableData={tableData}
        setTableData={setTableData}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
    </>
  );
};
